import { RouteRecordRaw } from 'vue-router';
import Login from '@/views/Autenticacion/Login/Login.vue';
import Logout from '@/views/Autenticacion/Logout/Logout.vue';
import LandingHome from '@/views/Landing/main.vue';

import ContratacionMX from '@/views/Landing/LandingMX/ContratacionTerrestre.vue';
import ContratacionAR from '@/views/Landing/LandingAR/ContratacionTerrestre.vue';
import ContratacionCH from '@/views/Landing/LandingCH/ContratacionTerrestre.vue';
import ContratacionES from '@/views/Landing/LandingES/ContratacionTerrestre.vue';
import ContratacionContempora from '@/views/Landing/LandingContempora/ContratacionTerrestre.vue';

import ContratacionMaritimaMX from '@/views/Landing/LandingMX/ContratacionMaritima.vue';
import ContratacionMaritimaAR from '@/views/Landing/LandingAR/ContratacionMaritima.vue';
import ContratacionMaritimaCH from '@/views/Landing/LandingCH/ContratacionMaritima.vue';
import ContratacionMaritimaES from '@/views/Landing/LandingES/ContratacionMaritima.vue';

import ContratacionPaqueteriaMX from '@/views/Landing/LandingMX/ContratacionPaqueteria.vue';
import ContratacionPaqueteriaAR from '@/views/Landing/LandingAR/ContratacionPaqueteria.vue';
import ContratacionPaqueteriaCH from '@/views/Landing/LandingCH/ContratacionPaqueteria.vue';
import ContratacionPaqueteriaES from '@/views/Landing/LandingES/ContratacionPaqueteria.vue';

import SendMailRecovery from './../views/Autenticacion/Login/SendMailRecovery.vue';
import RecuperarPassword from './../views/Autenticacion/Login/RecuperarPassword.vue';
import getSubDomainInitial from '../helpers/getSubDomainInitial';

const subDomainInitial = getSubDomainInitial();

const contratacionBySubDomain: Record<string, any> = {
  ARGENTINA: ContratacionAR,
  CHILE: ContratacionCH,
  MEXICO: ContratacionMX,
  SPAIN: ContratacionES,
  CONTEMPORA: ContratacionContempora,
};

const contratacionMaritimaBySubDomain: Record<string, any> = {
  ARGENTINA: ContratacionMaritimaAR,
  CHILE: ContratacionMaritimaCH,
  MEXICO: ContratacionMaritimaMX,
  SPAIN: ContratacionMaritimaES,
};

const contratacionPaqueteriaBySubDomain: Record<string, any> = {
  ARGENTINA: ContratacionPaqueteriaAR,
  CHILE: ContratacionPaqueteriaCH,
  MEXICO: ContratacionPaqueteriaMX,
  SPAIN: ContratacionPaqueteriaES,
};

const PublicRoutes: Array<RouteRecordRaw> = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
  },
  {
    path: '/send-mail-recovery',
    name: 'Send mail recovery',
    component: SendMailRecovery,
  },

  {
    path: '/recuperar-password',
    name: 'Recuperar password',
    component: RecuperarPassword,
  },
  {
    path: '/home',
    name: 'Home',
    component: LandingHome,
  },
  {
    path: '/contratacion',
    name: 'Contratacion',
    component: contratacionBySubDomain[subDomainInitial],
  },
  {
    path: '/contratacion-maritima',
    name: 'Contratacion Maritima',
    component:
      contratacionMaritimaBySubDomain[subDomainInitial] ??
      ContratacionMaritimaMX,
    meta: {
      subDomainInitial,
    },
  },
  {
    path: '/contratacion-paqueteria',
    name: 'Contratacion Paqueteria',
    component:
      contratacionPaqueteriaBySubDomain[subDomainInitial] ??
      ContratacionPaqueteriaMX,
    meta: {
      subDomainInitial,
    },
  },
  {
    path: '/thanks',
    name: 'Thanks',
    component: () => import('../views/Landing/Thanks.vue'),
  },
  {
    path: '/fail',
    name: 'Fail',
    component: () => import('../views/Landing/PaymentFail.vue'),
  },
  {
    path: '/approved-payment',
    name: 'ApprovedPayment',
    component: () =>
      import('../views/Landing/LandingContempora/ApprovedPayment.vue'),
  },
  {
    path: '/rejected-payment',
    name: 'RejectedPayment',
    component: () =>
      import('../views/Landing/LandingContempora/RejectedPayment.vue'),
  },
  {
    path: '/garantias-expresas-contempora',
    name: 'GarantiasExpresasContempora',
    component: () =>
      import(
        '../views/Landing/LandingContempora/GarantiasExpresasContempora.vue'
      ),
  },
  {
    path: '/logout',
    name: 'Logout',
    component: Logout,
  },
  {
    path: '',
    redirect: '/home',
  },
];

export default PublicRoutes;
